<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>
          <a-col :span="12">
            <a-form-item label="配置id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['setId', validatorRules.setId]" :disabled="ifEdit" placeholder="请输入配置id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="配置名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['setName', validatorRules.setName]" placeholder="请输入配置id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['status', validatorRules.status]"
                :trigger-change="true"
                dictCode="data_sync_status"
                placeholder="请选择状态"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头数据库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                :disabled="ifEdit"
                v-decorator="['sourceCode', validatorRules.sourceCode]"
                :trigger-change="true"
                dictCode="bus_data_sync_data_source,name,code"
                placeholder="请选择源头数据库"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否有序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                @add="OrderorNotAdd"
                v-decorator="['haveSeq', validatorRules.haveSeq]"
                :trigger-change="true"
                dictCode="yn"
                placeholder="请选择是否有序"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '1'">
            <a-form-item label="分组编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['groupNo', validatorRules.groupNo]" placeholder="请输入分组编码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '1'">
            <a-form-item label="组内顺序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['sequence', validatorRules.sequence]"
                placeholder="请输入组内顺序"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '0'">
            <a-form-item label="是否同步全部" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['syncAllFlag', validatorRules.syncAllFlag]"
                :trigger-change="true"
                dictCode="yn"
                placeholder="请选择是否同步全部"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="定时任务" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <m-ore-select :showType="true"
                            showTypeName="jobDesc"
                            showTypeValue="id"
                            v-decorator="['jobId', validatorRules.jobId]"
                            url="/base/busDataSyncBaseSet/getXxlJobList"
                            :asterisk="false"
                            :params="{}"
                            placeholder="请选择定时任务">
              </m-ore-select>
            </a-form-item>
          </a-col>
          <!-- 用于左右对齐 -->
          <a-col :span="12" v-show="haveSeq == '0'" style="opacity: 0;">
            <a-form-item label="是" :labelCol="labelCol" :wrapperCol="wrapperCol">
              1
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['dataTable', validatorRules.dataTable]" :disabled="ifEdit" placeholder="请输入源头业务表"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetTable', validatorRules.targetTable]"
                placeholder="请输入目标业务表" :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表主键" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['dataKey', validatorRules.dataKey]" :disabled="ifEdit" placeholder="请输入源头表主键"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表主键" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="ifEdit"
                v-decorator="['targetKey', validatorRules.targetKey]"
                placeholder="请输入目标业务表主键"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataField', validatorRules.dataField]"
                placeholder="请输入源头业务表字段"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetField', validatorRules.targetField]"
                placeholder="请输入目标业务表字段"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="过滤条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['dataFilter', validatorRules.dataFilter]" placeholder="请输入过滤条件"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="执行存储过程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataProcedure', validatorRules.dataProcedure]"
                placeholder="请输入执行的存储过程"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头删除记录表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataTableDel', validatorRules.dataTableDel]"
                placeholder="请输入源头删除记录表"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标删除记录表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetTableDel', validatorRules.targetTableDel]"
                placeholder="请输入目标删除记录表"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="删除执行存储过程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataProcedureDel', validatorRules.dataProcedureDel]"
                placeholder="请输入删除执行的存储过程"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="目标数据库" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="busDataSyncBaseSetTargetTable.loading"
            :columns="busDataSyncBaseSetTargetTable.columns"
            :dataSource="busDataSyncBaseSetTargetTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true"
          />
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import { VALIDATE_NO_PASSED,validateFormAndTables } from '@/utils/JEditableTableUtil'
import MOreSelect from './NAmeMOreSelect.vue'
export default {
  name: 'BusDataSyncBaseSetModal',
  mixins: [JEditableTableMixin],
  components: {
    JDictSelectTag,MOreSelect
  },
  data() {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 16
      },
      labelCol2: {
        span: 3
      },
      wrapperCol2: {
        span: 20
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        setId: { rules: [{ required: true, message: '请输入配置id!' }] },
        setName: { rules: [{ required: true, message: '请输入配置名称!' }] },
        jobId: { rules: [{ required: true, message: '请选择定时任务!' }] },
        dataTable: { rules: [{ required: true, message: '请输入源头业务表!' }] },
        dataKey: { rules: [{ required: true, message: '请输入源头业务表主键!' }] },
        dataField: { rules: [{ required: true, message: '请输入源头业务表字段!' }] },
        dataFilter: { rules: [] },
        dataProcedure: { rules: [] },
        dataTableDel: { rules: [] },
        sourceCode: { rules: [{ required: true, message: '请选择源头数据库!' }] },
        dataProcedureDel: { rules: [] },
        haveSeq: { rules: [{ required: true, message: '请选择是否有序' }] },
        sequence: { rules: [] },
        targetTable: { rules: [{ required: true, message: '请输入目标业务表!' }] },
        targetField: { rules: [{ required: true, message: '请输入目标业务表字段!' }] },
        targetKey: { rules: [{ required: true, message: '请输入目标业务表主键!' }] },
        targetTableDel: { rules: [] },
        groupNo: { rules: [] },
        syncAllFlag: { rules: [] },
        remarks: { rules: [] },
        status: { rules: [{ required: true, message: '请输入状态!' }] }
      },
      refKeys: ['busDataSyncBaseSetTarget'],
      tableKeys: ['busDataSyncBaseSetTarget'],
      activeKey: 'busDataSyncBaseSetTarget',
      // 基础数据同步目标数据库
      busDataSyncBaseSetTargetTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '目标数据库',
            key: 'targetCode',
            type: FormTypes.select,
            dictCode: 'bus_data_sync_data_source,name,code',
            width: '200px',
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [{ required: true, message: '${title}不能为空' }]
          }
        ]
      },
      url: {
        add: '/base/busDataSyncBaseSet/add',
        edit: '/base/busDataSyncBaseSet/edit',
        busDataSyncBaseSetTarget: {
          list: '/base/busDataSyncBaseSet/queryBusDataSyncBaseSetTargetByMainId'
        }
      },
      haveSeq: '' //是否有序
    }
  },
  computed: {
    ifEdit(){
      return !!this.model.id
    }
  },
  methods: {
    OrderorNotAdd(val) {
      this.haveSeq = val
    },
    /** 确定按钮点击事件 */
    handleOk() {
      console.log('6654');
      /** 触发表单验证 */
      this.getAllTable()
        .then(tables => {
          /** 一次性验证主表和所有的次表 */
          return validateFormAndTables(this.form, tables)
        })
        .then(allValues => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          let formData = this.classifyIntoFormData(allValues)
          // 增加是否有序判断
          if (formData.haveSeq == '1') {
            formData.syncAllFlag = null
          } else if (formData.haveSeq == '0') {
            formData.sequence = null
            formData.groupNo = null
          }
          // 发起请求
          return this.request(formData)
        })
        .catch(e => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
          } else {
            console.error(e)
          }
        })
    },
    getAllTable() {
      let values = this.tableKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(
        this.model,
        'setId',
        'jobId',
        'dataTable',
        'dataKey',
        'dataField',
        'dataFilter',
        'dataProcedure',
        'dataTableDel',
        'sourceCode',
        'dataProcedureDel',
        'haveSeq',
        'sequence',
        'targetTable',
        'targetField',
        'targetKey',
        'targetTableDel',
        'groupNo',
        'syncAllFlag',
        'remarks',
        'status',
        'setName'
      )
      this.OrderorNotAdd(this.model.haveSeq)
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      // 加载子表数据
      if (this.model.setId) {
        let params = { setId: this.model.setId }
        this.requestSubTableData(this.url.busDataSyncBaseSetTarget.list, params, this.busDataSyncBaseSetTargetTable)
      }
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)

      return {
        ...main, // 展开
        busDataSyncBaseSetTargetList: allValues.tablesValue[0].values
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'setId',
          'dataTable',
          'jobId',
          'dataKey',
          'dataField',
          'dataFilter',
          'dataProcedure',
          'dataTableDel',
          'sourceCode',
          'dataProcedureDel',
          'haveSeq',
          'sequence',
          'targetTable',
          'targetField',
          'targetKey',
          'targetTableDel',
          'groupNo',
          'syncAllFlag',
          'remarks',
          'status',
          'setName'
        )
      )
    }
  }
}
</script>

<style scoped></style>
<style lang="less" scoped>
  .ant-form-item{
    margin-bottom: 10px !important;
  }
</style>